import React, { useState, useEffect } from "react";
import { Tabs, Skeleton } from "antd";
import { UserOutlined, SettingOutlined } from "@ant-design/icons";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";
import UserProfileData from "./userProfileData";
import UserSetting from "./userSetting";

const USERPROFILEDATA = gql`
  query ($id: ID!) {
    getUser(id: $id) {
      createdAt
      updatedAt
      mobile
      userRole
      name
      fatherName
      nationalIdCardNo
      address
      birthDate
      gender
      birthCertificateNo
      degree
      expertise
      nationalIdCardImg
      birthCertificateImg
      profileImg
      confirmStatus
      confirmMessage
      deactivatedAt
      freeDayStatus
      otherDocs {
        docName
        docImg
      }
    }
  }
`;

function UserProfileControl({ id, onUserDataUpdate, onCloseDrawer }) {
  // const [error, setError] = useState(null);
  const [initialData, setInitialData] = useState({});
  const [formData, setFormData] = useState(null);

  const [getProfilelData, profileData] = useLazyQuery(USERPROFILEDATA, {
    fetchPolicy: "no-cache",
    onCompleted({ getUser }) {
      const profileData = {
        ...getUser,
        birthDate: getUser?.birthDate && moment(getUser?.birthDate),
      };
      setFormData(profileData);
      const {
        name,
        confirmStatus,
        confirmMessage,
        userRole,
        createdAt,
        updatedAt,
        deactivatedAt,
      } = getUser;
      setInitialData({
        name,
        confirmStatus,
        confirmMessage,
        userRole,
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
        deactivatedAt: deactivatedAt && moment(deactivatedAt).format("jYYYY/jMM/jDD"),
      });

    },
  });
  useEffect(() => {
    if (id) {
      getProfilelData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const userDataUpdated = () => {
    getProfilelData({
      variables: {
        id,
      },
    });

  };

  const {
    name,
    confirmStatus,
    confirmMessage,
    createdAt,
    updatedAt,
    deactivatedAt,
    userRole,
  } = initialData;

  const tabs = [
    {
      id: 1,
      label: "پروفایل",
      icon: <UserOutlined />,
      children: (
        <UserProfileData
          formData={formData}
          confirmStatus={confirmStatus}
          id={id}
          onDoUpdateUser={() => {
            onUserDataUpdate();
            userDataUpdated();
          }}
        />
      ),
    },
    {
      id: 2,
      label: "تنظیمات",
      icon: <SettingOutlined />,
      children: (
        <UserSetting
          onDoUpdateUser={() => {
            onUserDataUpdate();
            userDataUpdated();
          }}
          id={id}
          name={name}
          confirmStatus={confirmStatus}
          confirmMessage={confirmMessage}
          createdAt={createdAt}
          updatedAt={updatedAt}
          deactivatedAt={deactivatedAt}
          userRole={userRole}
          closeDrawer={onCloseDrawer}
        />
      ),
    },
  ];
  if (profileData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  if (formData)
    return (
      <>
        <Tabs
          defaultActiveKey="1"
          type="card"
          size="small"
          items={tabs.map((tab, i) => {
            return {
              label: (
                <span>
                  {tab.icon} {tab.label}
                </span>
              ),
              key: tab.id,
              children: tab.children,
            };
          })}
        />
      </>
    );
}

export default UserProfileControl;
